
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/post/[newsId]",
      function () {
        return require("private-next-pages/news/post/[newsId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/post/[newsId]"])
      });
    }
  